import { usePageHeader } from "@/containers/MobileHeaderContext";
import { useGoBack } from "@/hooks/useGoBack";
import { useTranslation } from "@repo/shared/i18n";

export const IosOrDesktopRequired = () => {
  const { t } = useTranslation("clubImport");
  // The one screen in the flow with nothing to do next — without a way out, a
  // visitor who arrived from My Club or an SBC is stranded on it.
  const goBack = useGoBack();

  // The arrow belongs to the top nav, like every other back control on mobile.
  usePageHeader({ title: t("tutorial.hero.title"), back: goBack });

  return (
    <div className="bg-panel-base min-h-screen px-4 py-6">
      <h1 className="text-white text-lg font-bold mb-2">{t("mobile.title")}</h1>
      <p className="text-dark-secondary text-sm mb-6">{t("mobile.subtitle")}</p>

      {/*
        No error icon: nothing has gone wrong and there is nothing to fix here —
        the device simply isn't one we support yet, and an Android version is on
        the way.
      */}
      <div className="bg-panel-background border border-new-gray-700 rounded-[15px] p-4 flex flex-col gap-2.5">
        <h2 className="text-white text-sm font-bold">
          {t("mobile.unsupported.title")}
        </h2>

        <div className="flex flex-col gap-2.5">
          <p className="text-white text-sm leading-5">
            {t("mobile.unsupported.body")}
          </p>
          <p className="text-dark-secondary text-sm leading-5">
            {t("mobile.unsupported.android")}
          </p>
        </div>
      </div>
    </div>
  );
};
